import {sendRequest} from "./genericHttpService";

export const sendForm = async (form) => {
    const url = "/api/canyonbook/form"
    try {
        await sendRequest.post(url, form);
    } catch (e) {
        throw new Error(`form sending operation has failed. Error: ${e}`);
    }
}